<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <div style="height: 5em;"></div>

    <!-- Breadcrumbs -->

    <div class="Breadcrumbs">

      <div class="box">

        <a href='/' class=''>{{ $t('message.faqBreadcrumbHome') }}</a> &gt; <a href='/service/' class=''>{{ $t('message.faqBreadcrumbService') }}</a> &gt; <a href='/FAQ/'>{{ $t('message.faqBreadcrumbFaq') }}</a>
      </div>

    </div>



    <!-- 问题解答 -->

    <div class="question-answer">

      <div class="box">

        <div class="left" >
<div style="position: relative;height: 0px;width: 800px">
          <div style="position: fixed;" :style="{ top: topValue + 'px' }">
            <h3 class="t1">{{ $t('message.faqQuestionAnswer') }}</h3>

            <div class="list">

              <ul  >


                <li  @click="move(1)"><h4><a href="javascript:;">{{ $t('message.faqQ1Title') }}</a></h4></li>


                <li   @click="move(2)" ><h4><a href="javascript:;">{{ $t('message.faqQ2Title') }}</a></h4></li>


                <li @click="move(3)"><h4><a href="javascript:;">{{ $t('message.faqQ3Title') }}</a></h4></li>


                <li @click="move(4)"><h4><a href="javascript:;">{{ $t('message.faqQ4Title') }}</a></h4></li>


                <li @click="move(5)"><h4><a href="javascript:;">{{ $t('message.faqQ5Title') }}</a></h4></li>


                <li @click="move(6)"><h4><a href="javascript:;">{{ $t('message.faqQ6Title') }}</a></h4></li>


                <li @click="move(7)"><h4><a href="javascript:;">{{ $t('message.faqQ7Title') }}</a></h4></li>


                <li @click="move(8)"><h4><a href="javascript:;">{{ $t('message.faqQ8Title') }}</a></h4></li>


              </ul>

            </div>


          </div>
</div>
        </div>
        <div class="right">

          <ul>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ1Title') }}</h2>

              <div class="txt">

                <p style="text-indent: 2em;">{{ $t('message.faqQ1Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ2Title') }}</h2>

              <div class="txt">

                <p>{{ $t('message.faqQ2Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ3Title') }}</h2>

              <div class="txt">

                <p style="text-indent: 2em;">{{ $t('message.faqQ3Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ4Title') }}</h2>

              <div class="txt">

                <p>{{ $t('message.faqQ4Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ5Title') }}</h2>

              <div class="txt">

                <p style="text-indent: 2em;">{{ $t('message.faqQ5Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ6Title') }}</h2>

              <div class="txt">

                <p style="text-indent: 2em;">{{ $t('message.faqQ6Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ7Title') }}</h2>

              <div class="txt">

                <p style="text-indent: 2em;">{{ $t('message.faqQ7Content') }}</p><p><br/></p>
              </div>

            </li>


            <li class="boxHigh">

              <h2 class="t1">{{ $t('message.faqQ8Title') }}</h2>

              <div class="txt">

                <p>{{ $t('message.faqQ8Content') }}</p><p><br/></p>
              </div>

            </li>


          </ul>

        </div>

      </div>

    </div>


<div style="  position: relative;">
    <Footer/>
</div>

  </div>



















</template>
<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      topValue: 220, // 初始top值
      isScrolled9: true,
      stickyPosition: 'fixed', // 初始化为固定定位
      question:[],
      loading: true,
      caseList: []
    };
  },
  created() {
    document.title = this.$t('message.faqTitle') + '_智慧林';
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll9);
    this.getData()
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {

          window.console.log(error);

        });
  },
  methods:{
    handleScroll9() {







      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;
      // 当滚动到500px时，将 topValue 设置为0px
      if (scrollY >= 220) {
        this.topValue = 10;
      } else {
        // 在其他情况下，根据滚动距离动态计算 topValue
        this.topValue = 220 - scrollY;
      }

      const bottomBarDistance = 800; // 接近底部栏的距离





      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    move(index){
      index=index*210
      window.scrollTo({
        top: index,
        behavior: 'smooth'
      });
      // index=100*index
      // window.scrollBy(0, index); // 滚动窗口向下滚动100px
    },
    // 滚动到指定的内容区域
    scrollToSection(index) {
      const sectionId = `section${index}`;
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    getData(){
      const headers = {// 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjEyMDkwYjRkLTdmZmYtNDFjNC05Yjk1LWRiOTMwZjRlYzA4YiJ9.pj2sxei6q_VIuHNvIelIJWqIso-JULIhR-unG0M0Wfcw9sX-evwM-FaVOfRAdoUewynuhvK-mdfHXoDay4a4pw',
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/11', { headers })
          .then(response => {
            // 请求成功时更新数据
            const data = response.data.data[0];
            this.question=data.children[2].archiveList;
            this.question= this.question.slice(0, 8);
            console.log(this.question)
          })

    },



  }
};
</script>

<style lang="scss" scoped>
.boxHigh{


  height: 230px;


}
.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}

.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
.left {
  width: 500px;
  word-break: break-all;
  word-wrap: break-word;
  float: left;
}
.right {
  margin-left: 220px;
}
</style>